export const StatusEnum = Object.freeze({
  DELIVERED: "DELIVERED",
  PARTIALLY_INVOICED: "PARTIALLY_INVOICED",
  FULLY_INVOICED: "FULLY_INVOICED",
});
